/* eslint-disable import/prefer-default-export */
import axios from '../../axios';

// ---------------------------------------------------------------------------
// RH / Recrutamento & Seleção — Vagas / aberturas (service layer, handoff 0061).
//
// `job_position_id` vem do catálogo de cargos existente (GET /hr/job-positions,
// exposto em services/hr/hrApi.listJobPositions). Ao criar, a vaga nasce ABERTA
// com opened_at = hoje; ao mudar status para ENCERRADA/PREENCHIDA o backend seta
// closed_at. Tradução camelCase → snake_case só aqui. Permissões:
// hr:job_opening:*.
//
// Nesta fatia (núcleo) só `listJobOpenings({ status: 'ABERTA' })` é consumido
// (picker de "puxar pra vaga"); o CRUD completo já entra para a fatia 2 (telas
// de Vagas) sem novo trabalho de service.
// ---------------------------------------------------------------------------

export async function listJobOpenings(filters = {}) {
   const { page, perPage, status, jobPositionId } = filters;

   const params = {};
   if (page) params.page = page;
   if (perPage) params.per_page = perPage;
   if (status) params.status = status;
   if (jobPositionId) params.job_position_id = jobPositionId;

   const response = await axios.get('/hr/recruitment/openings', { params });
   const envelope = response?.data ?? {};
   const data = envelope.data ?? {};
   const meta = envelope.meta ?? {};

   return {
      jobOpenings: data.openings ?? data.job_openings ?? [],
      total: meta.total ?? 0,
      page: meta.page ?? 1,
      perPage: meta.per_page ?? 20,
      totalPages: meta.total_pages ?? 1,
   };
}

export async function getJobOpening(jobOpeningId) {
   const response = await axios.get(
      `/hr/recruitment/openings/${jobOpeningId}`,
   );
   const data = response?.data?.data ?? {};
   return data.opening ?? data.job_opening ?? null;
}

export async function createJobOpening(payload) {
   const response = await axios.post('/hr/recruitment/openings', payload);
   const data = response?.data?.data ?? {};
   return {
      jobOpening: data.opening ?? data.job_opening ?? null,
      message: response?.data?.message ?? 'Vaga criada com sucesso.',
   };
}

export async function updateJobOpening(jobOpeningId, payload) {
   const response = await axios.put(
      `/hr/recruitment/openings/${jobOpeningId}`,
      payload,
   );
   const data = response?.data?.data ?? {};
   return {
      jobOpening: data.opening ?? data.job_opening ?? null,
      message: response?.data?.message ?? 'Vaga atualizada com sucesso.',
   };
}

// Backend responde 204 sem body (barra com 409 se houver candidatos).
export async function deleteJobOpening(jobOpeningId) {
   await axios.delete(`/hr/recruitment/openings/${jobOpeningId}`);
}
